import React from 'react';

const SubmitCampaignButton = ({
  onClick,
  disabled = false,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`rounded-full px-6 py-2 text-base text-white ${
        disabled
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-[#FF0050] hover:opacity-90'
      }`}
    >
      Submit Publish Request
    </button>
  );
};


export default SubmitCampaignButton;